var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vdtnet-table',{key:_vm.bookingsKey,ref:"table",attrs:{"fields":_vm.fields,"opts":_vm.options},on:{"viewBooking":_vm.viewBooking}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }